import { useEffect, useState } from "react";

import { api } from "../../lib/api";
import { getToken } from "../../storage/auth";
import { IncotermsComplementType } from "../../types/incotermsComplement";
import { List } from "../../types/resquest";
import {DataTableUtils} from "../../components/DataTable/DataTableUtils";

interface IList {
  keyword?: string;
  page?: number;
  limit?: number;
  sort?: string;
}

const entity = "incotermsComplements";
const dataTableUtils = new DataTableUtils(entity);

export const useList = (
  params?: IList,
  token?: string
): { data: IncotermsComplementType[]; meta: List; isLoading: boolean } => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<IncotermsComplementType[]>([
    {} as IncotermsComplementType,
  ]);
  const [meta, setMeta] = useState<List>({} as List);

  useEffect(() => {
    if (token) {
      (async function () {
        setIsLoading(true);
        const response = await dataTableUtils.findPaginate(params);
        const {total, data, currentPage, totalPages, limit} = response.data;
        setData(data);
        setMeta((prevState) => ({
          ...prevState,
          total,
          totalPages,
          limit,
          currentPage,
        }));
        setIsLoading(false)
      })();
    }
  }, [params, token]);

  return { data, meta, isLoading };
};

export const update = async (
  id: number | string,
  airport?: IncotermsComplementType
): Promise<IncotermsComplementType> => {
  const token = getToken();
  const { data } = await api.patch(`/${entity}/${id}`, airport, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const isInUse = async (id: number | string): Promise<any> => {
  const token = getToken();
  const { data } = await api.get(`/${entity}/isInUse/${id}`, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const deleteIncotermsComplement = async (
  id: number | string
): Promise<IncotermsComplementType> => {
  const token = getToken();
  const { data } = await api.delete(`/${entity}/${id}`, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const create = async (
  airport?: IncotermsComplementType
): Promise<IncotermsComplementType> => {
  const token = getToken();
  const { data } = await api.post(`/${entity}`, airport, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const exportAll = async (params: any) => {
  let xlsxData = [
    { label: "Id", value: "ID_INCOTERMS_COMPL" },
    { label: "Description", value: "DSC_INCOTERMS_COMPL" },
    {
      label: "Status",
      value: (row: any) => (row.ATIVO ? "Active" : "Inactive"),
    },
  ]
  await dataTableUtils.exportAll({params, xlsxData, filename: "IncotermsComplement"});
};
